import { LANGUAGES } from '../consts/languages';
import { IEntityContent, IEntityContentField } from '../interfaces/Common';

export enum CONTENT_FIELDS {
	NAME = 'name',
	CONTENT = 'content',
	POSTER_URL = 'posterurl',
	VIDEO_URL = 'videourl',
	FULL = 'content_full',
	ORDER_PAGE = 'content_order_page',
	APIS = 'apis',
}

type GetContentFieldArgs = {
	entityContent: IEntityContent | undefined;
	field: CONTENT_FIELDS;
	language: string;
	property?: keyof IEntityContentField;
};

export const getContentField = (args: GetContentFieldArgs) => {
	const {
		entityContent,
		field = CONTENT_FIELDS.NAME,
		language = LANGUAGES.en,
	} = args;

	const contentField = entityContent?.[language].find(
		(f: IEntityContentField) => f.name === `${field}_${language}`,
	);
	return contentField;
};

export const getContentFieldValue = (args: GetContentFieldArgs) => {
	const { property = 'content' } = args;
	const contentField = getContentField(args);
	return contentField ? contentField[property] : '';
};
